import React, { useContext, useEffect, useState } from 'react';
import { API, graphqlOperation, Auth } from "aws-amplify";
import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Pie, Bar, Line } from 'react-chartjs-2';
import { SpotContext } from '../../context/SpotContext';
import { getSpotResume, listSpotJDS } from '../../graphql/queries';

// Register ChartJS components
ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend);

const CrossJDDashboard = () => {
  const { companyjdlist } = useContext(SpotContext);
  const [isLoading, setIsLoading] = useState(true);
  const [spotJDs, setSpotJDs] = useState([]);
  const [completeCount, setCompleteCount] = useState(0);
  const [incompleteCount, setIncompleteCount] = useState(0);
  const [jdCounts, setJDCounts] = useState({});
  const [combinedJDResumes, setCombinedJDResumes] = useState([]);

  // Simulate loading data
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {

    const fetchSpotJDs = async () => {
      let spotJDItemsList = [];
      let currentNextToken = null;

      // Retrieve company profile from localStorage (it's an object with string values)
      const companyProfileString = localStorage.getItem('CompanyProfile');

      if (!companyProfileString) {
        console.error("No company profile found in localStorage");
        return;  // Exit if there's no company profile in localStorage
      }

      // Parse the string into an object
      let companyProfile;
      try {
        companyProfile = JSON.parse(companyProfileString);
      } catch (error) {
        console.error("Error parsing company profile:", error);
        return;  // Exit if parsing fails
      }

      // Access the email (it's a string in the object)
      const companyEmail = companyProfile.email;

      if (!companyEmail) {
        console.error("Company email is missing in the profile");
        return;  // Exit if there's no email in the profile
      }
      try {
        do {
          const response = await API.graphql(
            graphqlOperation(listSpotJDS, {
              filter: { companyEmail: { eq: companyEmail } },
              nextToken: currentNextToken,
            })
          );

          console.log("GraphQL response for Spot JDs:", response.data.listSpotJDS.items);

          // Ensure we're accessing the correct data structure
          const spotJDsData = response.data.listSpotJDS || {};
          const items = spotJDsData.items || [];

          // Set currentNextToken for pagination
          currentNextToken = spotJDsData.nextToken;

          // Append the fetched items to the list
          spotJDItemsList = [
            ...spotJDItemsList,
            ...items,
          ];
        } while (currentNextToken);

        // Set state with the fetched Spot JDs
        setSpotJDs(spotJDItemsList);  // This should be an array of all the items fetched
        console.log("Spot JDs State Set:", spotJDItemsList);

        // Calculate JD counts (complete and incomplete)
        const completeCount = spotJDItemsList.filter(
          (jd) =>
            jd.selectedCandidate && jd.selectedCandidate.length > 0 &&
            jd.filterCandidate && jd.filterCandidate.length > 0
        ).length;

        const incompleteCount = spotJDItemsList.filter(
          (jd) =>
            (!jd.selectedCandidate || jd.selectedCandidate.length === 0) ||
            (!jd.filterCandidate || jd.filterCandidate.length === 0)
        ).length;

        console.log(`Complete JDs: ${completeCount}`);
        setCompleteCount(completeCount);
        setIncompleteCount(incompleteCount);
        console.log(`Incomplete JDs: ${incompleteCount}`);

      } catch (error) {
        console.error('Error fetching Spot JDs:', error);
      }
    };

    // fetchSpotJDs();

  }, [])


  useEffect(() => {

    // const fetchJDWithResumes = async () => {
    //   let combinedList = [];
    //   let nextToken = null;

    //   // Get company email from localStorage
    //   const companyProfileString = localStorage.getItem("CompanyProfile");

    //   if (!companyProfileString) {
    //     console.error("No company profile found in localStorage");
    //     return;
    //   }

    //   let companyProfile;
    //   try {
    //     companyProfile = JSON.parse(companyProfileString);
    //   } catch (error) {
    //     console.error("Error parsing company profile:", error);
    //     return;
    //   }

    //   const companyEmail = companyProfile.email;

    //   try {
    //     do {
    //       const jdResponse = await API.graphql(
    //         graphqlOperation(listSpotJDS, {
    //           filter: { companyEmail: { eq: companyEmail } },
    //           nextToken: nextToken,
    //         })
    //       );

    //       const jdItems = jdResponse.data.listSpotJDS.items || [];
    //       nextToken = jdResponse.data.listSpotJDS.nextToken;

    //       const enrichedJDList = await Promise.all(
    //         jdItems.map(async (jd) => {
    //           let spotResumeData = null;

    //           if (jd.spotResumeID) {
    //             try {
    //               const resumeResponse = await API.graphql(
    //                 graphqlOperation(getSpotResume, { id: jd.spotResumeID })
    //               );
    //               spotResumeData = resumeResponse.data.getSpotResume;
    //             } catch (resumeError) {
    //               console.warn(`Failed to fetch SpotResume for JD ID ${jd.id}`, resumeError);
    //             }
    //           }

    //           return {
    //             ...jd,
    //             spotResume: spotResumeData,
    //           };
    //         })
    //       );

    //       combinedList = [...combinedList, ...enrichedJDList];
    //     } while (nextToken);

    //     setCombinedJDResumes(combinedList);
    //     console.log("✅ Filtered + Combined JD + Resume List:", combinedList);

    //   } catch (err) {
    //     console.error("❌ Error fetching SpotJDs and SpotResumes:", err);
    //   }
    // };

    // fetchJDWithResumes  ()



    const fetchJDWithResumes = async () => {
      let combinedList = [];
      let nextToken = null;
    
      // Get company email from localStorage
      const companyProfileString = localStorage.getItem("CompanyProfile");
    
      if (!companyProfileString) {
        console.error("No company profile found in localStorage");
        return;
      }
    
      let companyProfile;
      try {
        companyProfile = JSON.parse(companyProfileString);
      } catch (error) {
        console.error("Error parsing company profile:", error);
        return;
      }
    
      const companyEmail = companyProfile.email;
    
      // Helper function to extract emails from candidate string
      const extractEmails = (candidateString) => {
        if (!candidateString) return [];
        try {
          const parsed = JSON.parse(candidateString);
          if (!Array.isArray(parsed)) return [];
          return parsed.map(c => c.email).filter(email => typeof email === 'string');
        } catch (err) {
          console.error("Failed to parse candidate string:", err);
          return [];
        }
      };
    
      try {
        do {
          const jdResponse = await API.graphql(
            graphqlOperation(listSpotJDS, {
              filter: { companyEmail: { eq: companyEmail } },
              nextToken: nextToken,
            })
          );
    
          const jdItems = jdResponse.data.listSpotJDS.items || [];
          nextToken = jdResponse.data.listSpotJDS.nextToken;
    
          const enrichedJDList = await Promise.all(
            jdItems.map(async (jd) => {
              let spotResumeData = null;
    
              if (jd.spotResumeID) {
                try {
                  const resumeResponse = await API.graphql(
                    graphqlOperation(getSpotResume, { id: jd.spotResumeID })
                  );
                  spotResumeData = resumeResponse.data.getSpotResume;
                } catch (resumeError) {
                  console.warn(`Failed to fetch SpotResume for JD ID ${jd.id}`, resumeError);
                }
              }
    
              // Extract emails from JD and Spot Resume
              const jdFilterEmails = extractEmails(jd.filterCandidate);
              const jdSelectedEmails = extractEmails(jd.selectedCandidate);
    
              const resumeFilterEmails = extractEmails(spotResumeData?.filterCandidate);
              const resumeSelectedEmails = extractEmails(spotResumeData?.selectedCandidate);
    
              // Combine and remove duplicates from JD and Spot Resume emails
              const combinedFilterEmails = [
                ...new Set([...jdFilterEmails, ...resumeFilterEmails]),
              ];
              const combinedSelectedEmails = [
                ...new Set([...jdSelectedEmails, ...resumeSelectedEmails]),
              ];
    
              // Add emails to the JD object
              return {
                ...jd,
                spotResume: spotResumeData,
                filterEmails: combinedFilterEmails,     // Combined filter emails (JD + Spot Resume)
                selectedEmails: combinedSelectedEmails, // Combined selected emails (JD + Spot Resume)
              };
            })
          );
    
          combinedList = [...combinedList, ...enrichedJDList];
        } while (nextToken);
    
        setCombinedJDResumes(combinedList);
        setSpotJDs(combinedList)
        console.log("✅ Filtered + Combined JD + Resume List:", combinedList);


          // Calculate JD counts (complete and incomplete)
          const completeCount = combinedList.filter(
            (jd) =>
              jd.selectedCandidate && jd.selectedCandidate.length > 0 &&
              jd.filterCandidate && jd.filterCandidate.length > 0
          ).length;
  
          const incompleteCount = combinedList.filter(
            (jd) =>
              (!jd.selectedCandidate || jd.selectedCandidate.length === 0) ||
              (!jd.filterCandidate || jd.filterCandidate.length === 0)
          ).length;
  
          console.log(`Complete JDs: ${completeCount}`);
          setCompleteCount(completeCount);
          setIncompleteCount(incompleteCount);
          console.log(`Incomplete JDs: ${incompleteCount}`);




      } catch (err) {
        console.error("❌ Error fetching SpotJDs and SpotResumes:", err);
      }
    };
    
    fetchJDWithResumes();



  }, [])


  console.log("Combined JD + Resume List:", combinedJDResumes);


  const departmentKeywords = {
    engineering: ['developer', 'engineer', 'software', 'tech', 'javascript', 'react', 'frontend', 'backend', 'fullstack', 'AI Intern', 'AI Engineer',],
    sales: ['sales', 'business development', 'bdm', 'account executive'],
    marketing: ['marketing', 'seo', 'content', 'social media', 'growth'],
    hr: ['hr', 'human resource', 'talent', 'recruiter'],
    finance: ['finance', 'accounting', 'controller', 'financial'],
    operations: ['operations', 'ops', 'logistics', 'supply chain']
  };

  function categorizeJDs(spotJDs) {
    const counts = {
      engineering: 0,
      sales: 0,
      marketing: 0,
      hr: 0,
      finance: 0,
      operations: 0,
      others: 0
    };

    spotJDs.forEach(jd => {
      const name = jd.jdName.toLowerCase();
      let matched = false;

      for (const dept in departmentKeywords) {
        if (departmentKeywords[dept].some(keyword => name.includes(keyword))) {
          counts[dept]++;
          matched = true;
          break;
        }
      }

      if (!matched) {
        counts.others++;
      }
    });

    return counts;
  }

  useEffect(() => {
    const counts = categorizeJDs(spotJDs);
    setJDCounts(counts);
  }, [spotJDs]);

  console.log(jdCounts)


  const calculateDaysActive = (createdAt) => {
    const createdDate = new Date(createdAt);  // Parse the string to a Date object
    const currentDate = new Date(); // Get the current date
    const timeDifference = currentDate - createdDate; // Calculate difference in milliseconds
    const daysActive = Math.floor(timeDifference / (1000 * 3600 * 24)); // Convert milliseconds to days
    return daysActive;
  };


  // JD Status Distribution data
  const jdStatusData = {
    labels: ['Active', 'On Hold', 'Filled', 'Closed'],
    datasets: [
      {
        label: 'Job Descriptions',
        data: [spotJDs.length, incompleteCount, completeCount, 2],
        backgroundColor: [
          'rgba(102, 126, 234, 0.6)',
          'rgba(126, 96, 194, 0.6)',
          'rgba(146, 76, 174, 0.6)',
          'rgba(166, 56, 154, 0.6)',
        ],
        borderColor: [
          'rgba(102, 126, 234, 1)',
          'rgba(126, 96, 194, 1)',
          'rgba(146, 76, 174, 1)',
          'rgba(166, 56, 154, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  // Department JD Distribution data
  const departmentData = {
    labels: ['Engineering', 'Sales', 'Marketing', 'HR', 'Finance', 'Operations'],
    datasets: [
      {
        label: 'Job Descriptions',
        data: [jdCounts.engineering, jdCounts.sales, jdCounts.marketing, jdCounts.hr, jdCounts.finance, jdCounts.operations],
        backgroundColor: 'rgba(102, 126, 234, 0.6)',
        borderColor: 'rgba(102, 126, 234, 1)',
        borderWidth: 1,
      },
    ],
  };

  // Time to Fill data (in days)
  const timeToFillData = {
    labels: ['Engineering', 'Sales', 'Marketing', 'HR', 'Finance', 'Operations'],
    datasets: [
      {
        label: 'Average Days to Fill',
        data: [45, 32, 38, 25, 30, 35],
        backgroundColor: 'rgba(136, 89, 184, 0.6)',
        borderColor: 'rgba(136, 89, 184, 1)',
        borderWidth: 1,
      },
    ],
  };

  // Monthly trend data
  const monthlyTrendData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'New JDs',
        data: [4, 6, 8, 5, 7, 4],
        borderColor: 'rgba(102, 126, 234, 1)',
        backgroundColor: 'rgba(102, 126, 234, 0.2)',
        tension: 0.4,
      },
      {
        label: 'Filled Positions',
        data: [2, 3, 5, 4, 6, 3],
        borderColor: 'rgba(136, 89, 184, 1)',
        backgroundColor: 'rgba(136, 89, 184, 0.2)',
        tension: 0.4,
      },
    ],
  };

  // Options for bar charts
  const barOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  // Line chart options
  const lineOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Monthly Trends',
      },
    },
  };

  // Update the Pie chart options to add 3D effects:
  const pieOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        labels: {
          color: 'white',
          font: {
            size: 12
          },
          padding: 20
        }
      }
    },
    cutout: '40%',
    radius: '90%',
    animation: {
      animateScale: true,
      animateRotate: true
    }
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  return (
    // <div className="pt-[160px] min-h-screen bg-gradient-to-br from-[#1e3a8a] via-[#3b82f6] to-[#885bb8]">
    <div className='h-[70vh] overflow-y-auto overflow-x-hidden'>
      <div className="container mx-auto px-4">
        {/* Dashboard Header */}
        <div className="bg-white bg-opacity-10 p-6 rounded-xl border border-white border-opacity-20 backdrop-filter backdrop-blur-sm shadow-xl mb-8">
          <h2 className="text-3xl font-bold text-white">Cross-JD Analytics</h2>
          <p className="text-blue-100 mt-2">Performance Overview</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* KPI Cards */}
          <div className="bg-white bg-opacity-10 p-6 rounded-lg border border-white border-opacity-20">
            <h3 className="text-lg font-semibold mb-2">Overall Statistics</h3>
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-white bg-opacity-10 p-3 rounded-lg text-center">
                <p className="text-sm">Total JDs</p>
                <p className="text-2xl font-bold">{spotJDs?.length || 0}</p>
              </div>
              <div className="bg-white bg-opacity-10 p-3 rounded-lg text-center">
                <p className="text-sm">Active JDs</p>
                <p className="text-2xl font-bold">{incompleteCount}</p>
              </div>
              <div className="bg-white bg-opacity-10 p-3 rounded-lg text-center">
                <p className="text-sm">Avg. Time to Fill</p>
                <p className="text-2xl font-bold">36 days</p>
              </div>
              <div className="bg-white bg-opacity-10 p-3 rounded-lg text-center">
                <p className="text-sm">Hiring Success</p>
                <p className="text-2xl font-bold">78%</p>
              </div>
            </div>
          </div>

          {/* JD Status Chart */}
          <div className="bg-white bg-opacity-10 p-6 rounded-lg border border-white border-opacity-20">
            <h3 className="text-lg font-semibold mb-2">JD Status Distribution</h3>
            <div className="flex justify-center h-64">
              <Pie data={jdStatusData} options={pieOptions} />
            </div>
          </div>

          {/* Department Distribution Chart */}
          <div className="bg-white bg-opacity-10 p-6 rounded-lg border border-white border-opacity-20">
            <h3 className="text-lg font-semibold mb-2">JDs by Department</h3>
            <div className="h-64">
              <Bar data={departmentData} options={barOptions} />
            </div>
          </div>

          {/* Time to Fill by Department */}
          <div className="bg-white bg-opacity-10 p-6 rounded-lg border border-white border-opacity-20">
            <h3 className="text-lg font-semibold mb-2">Time to Fill by Department</h3>
            <div className="h-64">
              <Bar data={timeToFillData} options={barOptions} />
            </div>
          </div>
        </div>

        {/* Monthly Trends */}
        <div className="mt-8 bg-white bg-opacity-10 p-6 rounded-lg border border-white border-opacity-20">
          <h3 className="text-lg font-semibold mb-2">Monthly JD and Hiring Trends</h3>
          <div className="h-64">
            <Line data={monthlyTrendData} options={lineOptions} />
          </div>
        </div>

        {/* Top Performing JDs */}
        {/* <div className="mt-8 bg-white bg-opacity-10 p-6 rounded-lg border border-white border-opacity-20">
          <h3 className="text-lg font-semibold mb-2">Top Performing JDs</h3>
          <div className="overflow-x-auto">
            <table className="min-w-full text-white">
              <thead>
                <tr className="bg-white bg-opacity-10">
                  <th className="py-2 px-4 text-left">Job Title</th>
                  <th className="py-2 px-4 text-left">Department</th>
                  <th className="py-2 px-4 text-left">Applications</th>
                  <th className="py-2 px-4 text-left">Response Rate</th>
                  <th className="py-2 px-4 text-left">Days Active</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-white border-opacity-10">
                  <td className="py-2 px-4">Senior Developer</td>
                  <td className="py-2 px-4">Engineering</td>
                  <td className="py-2 px-4">42</td>
                  <td className="py-2 px-4">68%</td>
                  <td className="py-2 px-4">18</td>
                </tr>
                <tr className="border-b border-white border-opacity-10">
                  <td className="py-2 px-4">Sales Manager</td>
                  <td className="py-2 px-4">Sales</td>
                  <td className="py-2 px-4">35</td>
                  <td className="py-2 px-4">72%</td>
                  <td className="py-2 px-4">21</td>
                </tr>
                <tr className="border-b border-white border-opacity-10">
                  <td className="py-2 px-4">Marketing Specialist</td>
                  <td className="py-2 px-4">Marketing</td>
                  <td className="py-2 px-4">28</td>
                  <td className="py-2 px-4">65%</td>
                  <td className="py-2 px-4">24</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> */}

        <div className="mt-8 bg-white bg-opacity-10 p-6 rounded-lg border border-white border-opacity-20">
          <h3 className="text-lg font-semibold mb-2">Top Performing JDs</h3>
          <div className="overflow-x-auto">
            <table className="min-w-full text-white">
              <thead>
                <tr className="bg-white bg-opacity-10">
                  <th className="py-2 px-4 text-left">Job Title</th>
                  <th className="py-2 px-4 text-left">Department</th>
                  <th className="py-2 px-4 text-left">Applications</th>
                  <th className="py-2 px-4 text-left">Response Rate</th>
                  <th className="py-2 px-4 text-left">Days Active</th>
                </tr>
              </thead>
              <tbody>
                {spotJDs.map((job, index) => (
                  <tr key={index} className="border-b border-white border-opacity-10">
                    <td className="py-2 px-4">{job.jdName}</td>
                    <td className="py-2 px-4">{job.jdName}</td>
                    <td className="py-2 px-4">
                      {
                        (() => {
                          try {
                            const parsed = JSON.parse(job.selectedCandidate);
                            return Array.isArray(parsed) ? parsed.length : 0;
                          } catch (e) {
                            return 0;
                          }
                        })()
                      }
                    </td>
                    <td className="py-2 px-4">{job.responseRate}</td>
                    <td className="py-2 px-4">{calculateDaysActive(job.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
};

export default CrossJDDashboard;
